module.exports = __webpack_public_path__ + "img/img_cover_default_plan.20bc6829.png";